import { baseApi } from '../baseApi';

export const trialLabApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Trial Lab overview (list of mini-tests)
    getTrialLabOverview: builder.query({
      query: (params = {}) => ({
        url: '/student/trial-lab',
        params,
      }),
      providesTags: ['TrialLab'],
    }),

    // Get mini-test preview (full question data without answers)
    getTrialLabTest: builder.query({
      query: ({ testIndex, ...params }) => ({
        url: `/student/trial-lab/tests/${testIndex}`,
        params,
      }),
      providesTags: (result, error, { testIndex }) => [
        { type: 'TrialLabTest', id: testIndex },
      ],
    }),

    // Start a trial lab test session
    startTrialLabTest: builder.mutation({
      query: ({ testIndex, ...body }) => ({
        url: `/student/trial-lab/tests/${testIndex}/start`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TrialLab'],
    }),

    // Submit an answer within a session
    submitTrialLabAnswer: builder.mutation({
      query: ({ sessionId, ...body }) => ({
        url: `/student/trial-lab/sessions/${sessionId}/answer`,
        method: 'POST',
        body,
      }),
    }),

    // Complete a trial lab test session
    completeTrialLabTest: builder.mutation({
      query: (sessionId) => ({
        url: `/student/trial-lab/sessions/${sessionId}/complete`,
        method: 'POST',
      }),
      invalidatesTags: ['TrialLab', 'TrialLabHistory'],
    }),

    // Get session details (in-progress or completed)
    getTrialLabSession: builder.query({
      query: (sessionId) => `/student/trial-lab/sessions/${sessionId}`,
      providesTags: (result, error, sessionId) => [
        { type: 'TrialLabSession', id: sessionId },
      ],
    }),

    // Get attempt history
    getTrialLabHistory: builder.query({
      query: (params = {}) => ({
        url: '/student/trial-lab/history',
        params,
      }),
      providesTags: ['TrialLabHistory'],
    }),
  }),
});

export const {
  useGetTrialLabOverviewQuery,
  useLazyGetTrialLabOverviewQuery,
  useGetTrialLabTestQuery,
  useLazyGetTrialLabTestQuery,
  useStartTrialLabTestMutation,
  useSubmitTrialLabAnswerMutation,
  useCompleteTrialLabTestMutation,
  useGetTrialLabSessionQuery,
  useLazyGetTrialLabSessionQuery,
  useGetTrialLabHistoryQuery,
  useLazyGetTrialLabHistoryQuery,
} = trialLabApi;
